import { isString, toLower } from 'lodash';

export const isEqualIgnoreCase = (str1: string, str2: string) => toLower(str1) === toLower(str2);

export const truncateWithEllipsis = (text: string, maxLength: number) => {
    if (!text) return { truncatedDescription: '', isDescriptionTruncated: false };
    if (text.length <= maxLength) return { truncatedDescription: text, isDescriptionTruncated: false };

    const cutAt = text.lastIndexOf(' ', maxLength - 1);
    const safeCut = cutAt > 0 ? cutAt : maxLength;
    const base = text
        .slice(0, safeCut)
        .trim()
        .replace(/[.,;:!?]$/, '');

    return { truncatedDescription: `${base}...`, isDescriptionTruncated: true };
};

/**
 * Compares two strings for equality after normalization.
 *
 * Normalization rules:
 * - returns `false` if either value is not a string, or is empty/whitespace-only
 * - trims leading/trailing whitespace
 * - lowercases
 * - removes all non-alphanumeric characters (spaces, dashes, underscores, punctuation, etc.)
 *
 * Examples:
 * - "LB DAVITS" === "lb davits" === "lb-davits" === "lb_davits" -> true
 * - null / undefined / "" / "   " -> false
 */
export const isEqualNormalizedStrings = (a: string | null | undefined, b: string | null | undefined): boolean => {
    if (!isString(a) || !isString(b)) return false;

    const current = a.trim();
    const required = b.trim();

    if (!current || !required) return false;

    const normalize = (s: string) => toLower(s).replace(/[^a-z0-9]/g, '');

    return normalize(current) === normalize(required);
};

export const toPascalCase = (value: string): string =>
    value
        .split(/[^a-zA-Z0-9]+/)
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join('');
